import React from 'react';
import Text from './base';

const Hero = props => <Text defaultTag="h1" variant="hero" {...props} />;

export default Hero;
